// One store badge. With a URL it's a normal link; without one it renders
// dimmed and inert with a hover/focus "Coming soon" tooltip.
function StoreBadge({ url, badge, label, imgClass }) {
  if (url) {
    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center hover:scale-105 transition-transform"
      >
        <img src={badge} alt={label} className={`w-auto ${imgClass}`} />
      </a>
    );
  }
  return (
    <span
      tabIndex={0}
      aria-disabled="true"
      aria-label={`${label} — coming soon`}
      className="relative group inline-flex items-center cursor-not-allowed focus:outline-none"
    >
      <img src={badge} alt={label} className={`w-auto opacity-40 grayscale ${imgClass}`} />
      <span className="absolute -top-8 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-[var(--color-ink-main)] text-[var(--color-paper-bg)] text-xs font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 group-focus:opacity-100 transition-opacity pointer-events-none z-10">
        Coming soon
      </span>
    </span>
  );
}

export default StoreBadge;
